import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

/**
 * POST - Add or Update Rating
 * API: POST /api/rating/merchant/rating
 */
export const addOrUpdateRatingThunk = createAsyncThunk(
  "rating/addOrUpdate",
  async ({ merchantId, rating }, { rejectWithValue }) => {
    try {
      const res = await api.post("api/rating/merchant/rating", {
        merchantId,
        rating,
      });

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to submit rating"
      );
    }
  }
);

/**
 * GET - Ratings by Merchant
 * API: GET /api/rating/merchant/:merchantId/ratings
 */
export const fetchRatingsByMerchantThunk = createAsyncThunk(
  "rating/fetchByMerchant",
  async (merchantId, { rejectWithValue }) => {
    try {
      const res = await api.get(
        `api/rating/merchant/${merchantId}/ratings`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch merchant ratings"
      );
    }
  }
);

/**
 * GET - Ratings given by Logged-in User
 * API: GET /api/rating/user/ratings
 */
export const fetchUserRatingsThunk = createAsyncThunk(
  "rating/fetchUserRatings",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("api/rating/user/ratings");
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch user ratings"
      );
    }
  }
);
